import React from "react";

import { getNumberFontSize } from "../utils";
import { WidgetDisplayTypes } from "../../../api/dashboard.api";

// Helper hook for grabbing the fontSize
// Currently only number widget requires a fontSize setting.
export const useWidgetFontSize = (width: number, selectedView: WidgetDisplayTypes): string | null => {
  const fontSize = React.useMemo(() => {
    if (selectedView === WidgetDisplayTypes.Number) {
      return getNumberFontSize(width);
    }

    return null;
  }, [ width, selectedView ]);

  return fontSize;
};